<template>
    <div class="vm-album-intro" :class="[browser_size]">
        <router-link class="cover-box" :to="`/album/${album.album_id}`">
            <div
                class="inner-box darkbg"
                :style="{
                    backgroundImage: `url(${$img_src({
                        src: album.cover,
                        width: 320,
                        height: 320,
                        is_show_origin: white_list.ORIGIN_ALBUM_IMG_USERS.indexOf(album.user.user_id) != -1
                    })})`,
                }"
            >
                <!-- <pic class="self-center" :src="album.cover" width="320" height="320" /> -->
            </div>
        </router-link>
        <section class="intro-box">
            <router-link
                class="tit fwb fs30 mt32 block text-center"
                :to="`/album/${album.album_id}`"
            >{{ album.title }}</router-link>
            <div class="fs14 black-8 mt16 text-center">{{ album.content }}</div>
            <div class="flex-box flex-center flex-align-items-center mt16">
                <avatar class="wh24" :user="album.user"/>
            </div>
            <div class="fs14 black-3 mt16 flex-box flex-center">
                <!-- <div class>
          <span v-text="$time_show(album.publish_time)"></span>更新
                </div>-->
                <share :config="share_config"></share>
                <router-link
                    class="mr20 gl-hover-text ml40"
                    v-if="album.can_edit"
                    :to="`/edit/album?album_id=${album.album_id}`"
                >{{$t('c.AlbumIntro.text1')}}</router-link>
            </div>
        </section>
        <div class="btn-box">
             <btn
                v-if="browser_size == 'small' && !is_applying_apple"
                class="look8 fs16 edit-btn mr8"
                @click.native="tap"
            >{{$t('c.AlbumIntro.text2')}}({{ album.post_count }})</btn>

            <router-link
                v-if="!is_applying_apple && !is_applying_google && album.hasUnlockAll == 0 && album.hasPlanUnlock == 1"
                :to="`/a/${album.user.url_slug}/plan?album_id=${album.album_id}`"
                class="mr8"
            >
                <btn class="fadian-btn">{{$t('c.AlbumIntro.text3')}}</btn>
            </router-link>
            <!-- <btn
        v-if="session_user && session_user.user_id == album.user.user_id"
        class="look1 fs16 edit-btn"
        @click.native="$mixin_router_push(`/edit/album?album_id=${album.album_id}`)"
            >编辑</btn>-->

            <btn
                v-if="!is_applying_apple && !is_applying_google && album.hasUnlockAll == 0 && album.hasBuyUnlock == 1"
                class="look11 fs16 buy-btn"
                @click.native="order">
            <template v-if="album.buyPlan && album.buyPlan.price">￥ {{album.buyPlan.price}}</template>
            {{$t('c.AlbumIntro.text4')}}<template v-if="album.user_id == '51877d1637a511ec82bc52540025c377'">{{$t('c.AlbumIntro.text5')}}</template>
            </btn>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        album: {},
    },
    data() {
        return {
            //   n: this.browser_size == "small" ? 2 : 3
        };
    },
    computed: {
        ...mapState("app", ["session_user",'is_applying_apple','is_applying_google','white_list']),
        share_config() {
            let wx_description = this.$safe_substr(this.album.content, 0, 15)
            return {
                url: window.location.href,
                source: `${location.origin}`,
                title: document.title,
                description: `${this.album.user && this.album.user.name}在爱发电分享了 TA 的作品集：《${this.album.title}》，${this.album.content.substring(0,15)}...快来围观吧！（分享自@爱发电）`,
                wx_description,
                album: this.album,
                pic: this.$img_src({
                    src: this.album.cover,
                    width: 320,
                    height: 320,
                }),
                extra_btns: [
                    {
                        func_name: "share_album",
                        param: {
                            album: this.album,
                        },
                        icon: `${this.GL.PIC_HOST}/static/img/icon-saveimage.png`,
                        title: "保存图片并分享",
                    },
                ],
            };
        },
    },
    beforeDestroy() {
      this.$bus.$off("DOCUMENT_TITLE_CHANGE");
    },
    mounted() {
        this.$emit('mounted')
        this.$bus.$on("DOCUMENT_TITLE_CHANGE", (data) => {
          this.share_config.title = document.title
        });
    },
    methods: {
        tap() {
            this.$mixin_show_modal_album({
                album_id: this.album.album_id,
                post_count: this.album.post_count,
            });
        },
        order(){
            this.$router.push({
                path: "/order/create",
                query: {
                    product_type: 1,
                    plan_id: this.album.buyPlan.plan_id,
                    sku:JSON.stringify([{
                        sku_id: this.album.buyPlan.sku_id,
                        count:1
                    }]),
                },
            });
        }
    },
};
</script>

<style lang="stylus" scoped>
.vm-album-intro{
    .cover-box {
        flex-shrink: 0;
        height: auto;
        display: block;
        box-shadow: $layer-shadow;
        border-radius: 8px;

        .inner-box {
            // background: rgba(234, 234, 234, 1);
            padding-bottom: 100%;
            position: relative;
            height: auto;
            border-radius: 8px;
            overflow: hidden;
            background-size: cover;
            background-position: center;

            img {
                object-fit: cover;
            }
        }
    }

    .buy-btn{
            margin-top:16px;
        }

    .vm-avatar /deep/{
        align-items: center;
    }

    .btn-box {
        padding: 16px 0 30px 0;
        display: block;
        margin-top: 40px;

        .edit-btn {
            margin-top: 16px;
        }

        .vm-btn {
            padding-top: 20px;
            padding-bottom: 20px;
            width: 100%;
        }
    }

    &.small {
        .btn-box {
            position: fixed;
            display: flex;
            justify-content: center;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 16px 60px 30px 60px;
            box-sizing: border-box;
            // background: $white;
            z-index: 11;
        }
        .buy-btn{
            margin-left:8px;
            margin-top:0px;

        }

        .intro-box {
            padding: 0 20px;
        }

        .cover-box {
            margin: 0 20px;
        }

        .edit-btn {
            margin-top: 0px;
            // margin-left: 8px;
            background: $white;
        }

        .vm-btn {
            padding-top: 13px;
            padding-bottom: 13px;
            box-shadow: $layer-shadow;

            &.look8 {
                padding-top: 12px;
                padding-bottom: 12px;
            }
        }
    }
}
</style>
